import { render, staticRenderFns } from "./GoodsRequestApproval.vue?vue&type=template&id=f4c5f830&scoped=true"
import script from "./GoodsRequestApproval.vue?vue&type=script&lang=js"
export * from "./GoodsRequestApproval.vue?vue&type=script&lang=js"
import style0 from "./GoodsRequestApproval.vue?vue&type=style&index=0&id=f4c5f830&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4c5f830",
  null
  
)

export default component.exports